import { ToastProgrammatic as Toast } from "buefy";
import { BNoticeConfig } from "buefy/types/components";
import { ColorModifiers, GlobalPositions } from "buefy/types/helpers";

export function launchToast(
  message: string,
  type: ColorModifiers = "is-danger",
  duration = 5000,
  position: GlobalPositions = "is-bottom"
): void {
  const options: BNoticeConfig = {
    duration: duration,
    message: message,
    type: type,
    position: position,
  };
  Toast.open(options);
}
